import { isEmbedded } from './embed-mode'
let prefix = 'lx-web'
// 同域 iframe 的 sessionStorage 也可能与父页共享，嵌入身份完全保存在当前文档内存。
const memory = () => {
  let values = {}
  return { getItem: key => values[key] || null, setItem: (key, value) => { values[key] = String(value) },
    removeItem: key => { delete values[key] }, clear: () => { values = {} } }
}
const localStorage = isEmbedded ? memory() : window.localStorage
const sessionStorage = isEmbedded ? memory() : window.sessionStorage
export default {
  keys: {
    member: 'member',
    user: 'user'
  },
  get (name) {
    let value = localStorage.getItem(prefix + name)
    if (/^\{.*\}$/.test(value)) value = JSON.parse(value)
    return value
  },
  set (name, value) {
    if (typeof value == typeof {}) value = JSON.stringify(value)
    localStorage.setItem(prefix + name, value)
  },
  remove (name) {
    localStorage.removeItem(prefix + name)
  },
  clear () {
    localStorage.clear()
  },
  getSession (name) {
    let value = sessionStorage.getItem(prefix + name)
    if (/^\{.*\}$/.test(value)) value = JSON.parse(value)
    return value
  },
  setSession (name, value) {
    if (typeof value == typeof {}) value = JSON.stringify(value)
    sessionStorage.setItem(prefix + name, value)
  },
  removeSession (name) {
    sessionStorage.removeItem(prefix + name)
  },
  clearSession () {
    sessionStorage.clear()
  },
  getUser () {
    return this.getSession(this.keys.user)
  },
  setUser (value) {
    this.setSession(this.keys.user, value)
  },
  getMember () {
    return this.get(this.keys.member)
  },
  setMember (value) {
    this.set(this.keys.member, value)
  }
}



// WEBPACK FOOTER //
// ./src/service/storage-service.js